import { connect } from 'react-redux'
import ProfileComponent from '../../components/profile/profile.component'
import {
  getProfessions,
  updateProfile,
  loadProfileStart,
  closeProfileSnackbar,
  getUserInfo,
  getAdminUsersList,
  resetScrollToSSN,
  getFieldOfWork,
  getLogo,
  closeLogoSnackbar,
  getUserCompanyUpdateInfo,
  getTaxCard
} from '../../actions'
import { LOGOUT } from '../../constants'

const mapStateToProps = (state) => {
  const { client, adminUser } = state
  const userType = client.user.data[5]
  const fieldOfWork = state.profile.fieldOfWork ? state.profile.fieldOfWork : []
  return {
    fieldOfWork: fieldOfWork,
    titleItems: state.profile.titleItems,
    showProfileSnackbar: state.profile.showProfileSnackbar,
    showFailSnackbar: state.profile.showFailSnackbar,
    userType,
    state,
    selectedUser: adminUser.selectedUser,
    scrollToSSN: state.profile.scrollToSSN,
    showSsnWarningSnackbar: state.profile.showSsnWarningSnackbar,
    logoSaved: state.logo.logoSaved,
    logoSaveFailed: state.logo.logoSaveFailed,
    deleteLogoSuccess: state.logo.deleteLogoSuccess,
    deleteLogoFailed: state.logo.deleteLogoFailed,
    isInvalidLogo: state.logo.isInvalidLogo,
    isCorruptLogo: state.logo.isCorruptLogo,
    userData: state.profile.userData,
    updateUserEmailSuccess: state.profile.updateUserEmailSuccess
  }
}

const mapDispatchToProps = (dispatch) => {
  return {
    dispatch,
    getProfessions: () => dispatch(getProfessions()),
    getFieldOfWork: () => dispatch(getFieldOfWork()),
    updateProfile: (formValues) => dispatch(updateProfile(formValues)),
    loadProfileStart: () => dispatch(loadProfileStart()),
    closeProfileSnackbar: () => dispatch(closeProfileSnackbar()),
    getUserInfo: (data) => dispatch(getUserInfo(data)),
    getAdminUsersList: () => dispatch(getAdminUsersList()),
    resetScrollToSSN: () => dispatch(resetScrollToSSN()),
    getLogo: (data) => dispatch(getLogo(data)),
    closeLogoSnackbar: () => dispatch(closeLogoSnackbar()),
    getUserCompanyUpdateInfo: () => dispatch(getUserCompanyUpdateInfo()),
    getTaxCard: () => dispatch(getTaxCard()),
    handlemanuallogout: () => {
      dispatch({ type: LOGOUT })
    }
  }
}

const ProfileContainer = connect(
  mapStateToProps,
  mapDispatchToProps
)(ProfileComponent)

export default ProfileContainer
